import { Row, Col, Button } from "react-bootstrap";
import DeliveryMethods from "../../components/alertPrefernces/DeliveryMethods";
import AlertTypes from "../../components/alertPrefernces/AlertTypes";
import NotificationTiming from "../../components/alertPrefernces/NotificationTiming";
import AlertLocations from "../../components/alertPrefernces/ AlertLocations";
import AdditionalSettings from "../../components/alertPrefernces/AdditionalSettings";
import RightPanel from "../../components/alertPrefernces/RightPanel";
import { FaBell } from "react-icons/fa";
import { useEffect, useState } from "react";
import Notifications from "../../components/alertPrefernces/Notifications";
import {successAlert,  errorAlert } from "../../components/common/Alert";
import { getNotificationsApi, getNotificationsPreference } from "../../services/Networkcall";


export default function AlertPreferences() {
    const [notifications, setNotifications] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, limit: 50, totalPages: 1, totalRecords: 1 })
    const [notificationPreference, setNotificationPreference] = useState({});
    const [channels, setChannels] = useState({
            "email": false,
            "sms": false,
            "inApp": true
    });
    const [alertTypes, setAlertTypes] = useState([
            {
                "type": "DRIVER_ENTERED",
                "enabled": false,
                "_id": "6a4e04daafc326d623d5515f"
            },
            {
                "type": "BOOKING_CREATED",
                "enabled": false,
                "_id": "6a4e04daafc326d623d55160"
            }
    ])
    const [alertLocations, setAlertLocations] = useState(["691c7670fc5bfc2069adcca1"]);

    const [loading, setLoading] = useState(false)


    const fetchNotifications = async () => {
        setLoading(true)
        try {
            const res = await getNotificationsApi({ page: pagination?.page, limit: pagination?.limit });
            if (res?.success) {
                setNotifications(res?.data || [])
                setPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }));
            } else {
                errorAlert({message:res?.message || 'Failed to fetch notifications.'})
            }
        } catch (err) {
         errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
        } finally {
            setLoading(false);
        }
    }

     const fetchNotificationsPreferences = async () => {
        setLoading(true)
        try {
            const res = await getNotificationsPreference();
            if (res?.success) {
                setNotificationPreference(res?.data);
                setChannels(res?.data?.channels || {});
                setAlertTypes(res?.data?.alertTypes || []);
                setAlertLocations(res?.data?.locations || []);
            } else {
                errorAlert({message:res?.message || 'Failed to fetch notifications.'})
            }
        } catch (err) {
         errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
        } finally {
            setLoading(false);
        }
     }
    
    const saveNotificationsPreferences = () => {
        setLoading(true);
        const payload = {
            "channels": channels,
            "alertTypes": alertTypes,
            "locations": alertLocations,
        }
        try {
            const res = saveNotificationsPreferences(payload);
            if (res?.sucess) {
                successAlert({ message: res?.message || "Notifications Preference updated successfully." });
                fetchNotificationsPreferences();
            } else {
                errorAlert({message : res?.message || "something went wrong."})
            }
        } catch (err) {
           errorAlert({message : err?.response?.message || err?.message || "something went wrong."})
        } finally {
            setLoading(false);
        }

    }

    const handleCancelClick = () => {
        setChannels(notificationPreference?.channels);
        setAlertTypes(notificationPreference?.alertTypes);
        setAlertLocations(notificationPreference?.locations);
    }

    useEffect(() => {
        fetchNotifications();
        // fetchNotificationsPreferences();
    }, [])



    
     


    return (
        <div className="ap-page vh-100 overflow-scroll">

            {/* HEADER */}
            <div className="ap-header">
                <div>
                    <h4>Alerts & Notifications</h4>
                    <p>Choose how and when you want to be notified.</p>
                </div>

                <div className="ap-actions">
                    <Notifications notifications={notifications} loading={loading} />
                </div>
            </div>

            {/* CONTENT */}
            <Row className="ap-layout">

                {/* LEFT */}
                <Col xl={8} lg={12}>
                    <DeliveryMethods channels={channels} setChannels={setChannels} />
                    <AlertTypes types={alertTypes} setTypes={setAlertTypes} />
                    <Row>
                        {/* <Col md={6}>
                            <NotificationTiming />
                        </Col>   */}
                        {/* <Col md={8}>
                            <AlertLocations locations={alertLocations} setLocations={setAlertLocations} />
                        </Col> */}
                       {/* <Col md={6}>
                           <AdditionalSettings />
                        </Col> */}
                    </Row>
                    

                    {/* <div className="ap-footer">
                        <Button variant="light" onClick={handleCancelClick}>Cancel</Button>
                        <Button variant="primary" onClick={saveNotificationsPreferences}>Save Preferences</Button>
                    </div> */}
                </Col>

                {/* RIGHT */}
                <Col xl={4} lg={12}>
                    <RightPanel notifications={notifications} />
                </Col>

            </Row>

        </div>
    );
}